// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__1hkwq","left":"StickyBox_left__2lz0M","right":"StickyBox_right__40NvT"};